const nascar = {
  player_records: 'driver_records',
  player: { label: 'Driver (#)', property: 'driver' },
  eventStats: {
    in_progress: [{ label: 'Start', property: 'starting_position' }],
    final: [{ label: 'Points', property: 'points' }],
  },
  matchupCards: {
    eventElements: [
      {
        label: 'results',
        property: 'driver_records',
        event_status: ['final'],
        stats: [{ label: 'Points', property: 'points' }],
      },
      {
        label: 'qualifiers',
        property: 'event_drivers',
        event_status: ['in_progress', 'final'],
        stats: [
          { label: 'Make', property: 'car.make' },
          { label: 'Time', property: 'qualifying_time' },
        ],
      },
    ],
  },
  matchupDescriptionElements: [
    { properties: ['game_date'], type: 'date', format: 'MMMM Do YYYY, h:mm a' },
    { properties: ['location'], type: 'text' },
    {
      label: 'Completed Laps',
      properties: ['laps_completed', 'laps'],
      type: 'text',
      seperator: ' of ',
    },
    { label: 'Distance', properties: ['distance'], type: 'text', format: '%[0] miles' },
    { label: 'Previous Winner', properties: ['previous_winner.full_name'], type: 'text' },
    {
      label: 'TV Coverage',
      properties: ['tv_listings_by_country_code.us[0].short_name'],
      type: 'text',
      event_status: ['pre_game', 'in_progress'],
    },
  ],
};

const formula1 = {
  player_records: 'driver_records',
  player: { label: 'Driver (#)', property: 'driver' },
  eventStats: {
    in_progress: [{ label: 'Start', property: 'starting_position' }],
    final: [
      { label: 'Points', property: 'points' },
      { label: 'Time', property: 'finishing_time.formatted' },
    ],
  },
  matchupCards: {
    eventElements: [
      {
        label: 'results',
        property: 'driver_records',
        event_status: ['final'],
        stats: [
          { label: 'Time', property: 'finishing_time.formatted' },
          { label: 'Points', property: 'points' },
        ],
      },
      {
        label: 'qualifiers',
        property: 'event_drivers',
        event_status: ['in_progress', 'final'],
        stats: [
          { label: 'Team', property: 'driver.teams[0].medium_name' },
          { label: 'Q3', property: 'qualifying_time', type: 'time' },
        ],
      },
    ],
  },
  matchupDescriptionElements: [
    { properties: ['game_date'], type: 'date', format: 'MMMM Do YYYY, h:mm a' },
    { properties: ['location'], type: 'text' },
    {
      label: 'Completed Laps',
      properties: ['laps_completed', 'laps'],
      type: 'text',
      seperator: ' of ',
    },
    { label: 'Distance', properties: ['distance'], type: 'text', format: '%[0] miles' },
    { label: 'Previous Winner', properties: ['previous_winner.full_name'], type: 'text' },
    {
      label: 'TV Coverage',
      properties: ['tv_listings_by_country_code.ca[0].short_name'],
      type: 'text',
      event_status: ['pre_game', 'in_progress'],
    },
  ],
};

const wta = {
  matchupCards: {
    eventElements: [{ property: 'matches' }, { property: 'schedule' }],
    eventCardDescriptions: {
      default: {
        properties: ['description'],
        type: 'text',
      },
      pre_game: {
        properties: ['match_date'],
        type: 'date',
        format: 'h:mm A',
      },
    },
  },
  matchupDescriptionElements: [
    {
      properties: ['start_date', 'end_date'],
      type: 'date',
      format: 'MMM Do YYYY, h:mm a',
      seperator: ' - ',
    },
    { properties: ['location'], type: 'text' },
    { label: 'Surface', properties: ['ground_type'], type: 'text' },
    { label: 'Type', properties: ['tournament_type'], type: 'text' },
  ],
};

const atp = {
  matchupCards: {
    eventElements: [{ property: 'matches' }, { property: 'schedule' }],
    eventCardDescriptions: {
      default: {
        properties: ['description'],
        type: 'text',
      },
      pre_game: {
        properties: ['match_date'],
        type: 'date',
        format: 'h:mm A',
      },
    },
  },
  matchupDescriptionElements: [
    {
      properties: ['start_date', 'end_date'],
      type: 'date',
      format: 'MMM Do YYYY, h:mm a',
      seperator: ' - ',
    },
    { properties: ['location'], type: 'text' },
    { label: 'Surface', properties: ['ground_type'], type: 'text' },
    { label: 'Type', properties: ['tournament_type'], type: 'text' },
  ],
};

const mma = {
  player: { property: 'fighter' },
  matchupCards: {
    eventElements: [{ property: 'fights' }],
    eventCards: [
      { label: 'Main Card', property: 'card', value: 'main_card', playerRecord: 'record' },
      { label: 'Preliminary Card', property: 'card', value: 'undercard', playerRecord: 'record' },
    ],
    eventCardDescriptions: {
      default: {
        properties: ['weight_class_description'],
        type: 'text',
      },
      final: {
        properties: ['victory.time', 'victory.round', 'weight_class_description'],
        type: 'text',
        format: '%[0] Round %[1] - %[2]',
      },
    },
  },
  victory: {
    disqualification: 'DQ',
    forfeit: 'FF',
    knockout: 'KO',
    majority_decision: 'MD',
    majority_draw: 'MDRAW',
    split_decision: 'SD',
    split_draw: 'SDRAW',
    submission: 'SUB',
    tko: 'TKO',
    technical_decision: 'TD',
    technical_draw: 'TDRAW',
    technical_submission: 'TSUB',
    unanimous_decision: 'UD',
    unanimous_draw: 'UDRAW',
  },
  matchupDescriptionElements: [
    { properties: ['venue', 'location'], type: 'text', seperator: ', ' },
    { properties: ['start_datetime'], type: 'date', format: 'MMMM Do YYYY, h:mm a' },
  ],
};

export default {
  nascar,
  formula1,
  wta,
  atp,
  mma,
};
